var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.437,
    height: 14.635,
    viewBox: "0 0 15.437 14.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profil_icon",
    "data-name": "profil icon",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 3.492,
    cy: 3.447,
    rx: 3.492,
    ry: 3.447,
    transform: "translate(3.476)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M11048.508,6332.444a7.342,7.342,0,0,0-6.969,5.034h13.937A7.343,7.343,0,0,0,11048.508,6332.444Z",
    transform: "translate(-11041.539 -6324.343)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconBlack);
export default __webpack_public_path__ + "static/media/profile-icon-black.4dacf583df5af4baaa503330234236c0.svg";
export { ForwardRef as ReactComponent };